import React from 'react';
import { useAuth } from '../../../../AuthContext';

interface IdentityFooterProps {
  onToggleChangePassword: () => void;
  changePasswordOpen: boolean;
  onLogout: () => void;
}

/**
 * Pinned identity row at the bottom of the profile view: the person's name
 * in two rows (first / rest) — no email, no location — plus the key
 * (change password) and logout glass icon buttons.
 */
const IdentityFooter: React.FC<IdentityFooterProps> = ({
  onToggleChangePassword,
  changePasswordOpen,
  onLogout,
}) => {
  const { user } = useAuth();

  const fullName = (user?.full_name ?? '').trim();
  const [first, ...rest] = fullName.split(/\s+/);
  const rowOne = fullName ? first : user?.username || '';
  const rowTwo = fullName ? rest.join(' ') : '';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontFamily: "'Inter Tight', sans-serif",
            fontWeight: 700,
            fontSize: 20,
            lineHeight: 1.15,
            color: 'var(--text)',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {rowOne}
        </div>
        {rowTwo && (
          <div
            style={{
              fontFamily: "'Inter Tight', sans-serif",
              fontWeight: 700,
              fontSize: 20,
              lineHeight: 1.15,
              color: 'var(--text)',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {rowTwo}
          </div>
        )}
      </div>

      <button
        type="button"
        className="tend-btn tend-btn--icon"
        title="Change password"
        aria-label="Change password"
        onClick={onToggleChangePassword}
        style={changePasswordOpen ? { color: '#fff', background: 'rgba(255,255,255,.18)' } : undefined}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 7a2 2 0 012 2m3 0a5 5 0 01-5.9 4.9L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.6a1 1 0 01.3-.7l6.8-6.8A5 5 0 1120 9z"
          />
        </svg>
      </button>

      <button
        type="button"
        className="tend-btn tend-btn--icon"
        title="Log out"
        aria-label="Log out"
        onClick={onLogout}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
          />
        </svg>
      </button>
    </div>
  );
};

export default IdentityFooter;
